import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import TextField, {TextFieldProps} from '@mui/material/TextField';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  handleChange?: (e: any) => void;
};

export default function RHFTextField({
  name,
  helperText,
  type,
  handleChange,
  ...other
}: Props) {
  const {control} = useFormContext();
  const {t} = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          value={type === 'number' && field.value === 0 ? '' : field.value}
          onChange={event => {
            if (type === 'number') {
              field.onChange(Number(event.target.value));
              if (handleChange) handleChange(event);
            } else {
              field.onChange(event.target.value);
              if (handleChange) handleChange(event);
            }
          }}
          error={!!error}
          helperText={
            error
              ? (typeof error.message === 'string'
                  ? t(error.message, {ns: 'public'})
                  : '') || helperText
              : helperText
          }
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#0000003b',
              borderWidth: '1.8px'
            }
          }}
          {...other}
        />
      )}
    />
  );
}
